import { render, staticRenderFns } from "./DashboardAdmin.vue?vue&type=template&id=1bfda512&scoped=true"
import script from "./DashboardAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardAdmin.vue?vue&type=script&lang=js"
import style0 from "./DashboardAdmin.vue?vue&type=style&index=0&id=1bfda512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfda512",
  null
  
)

export default component.exports